import React from 'react';
import { Error as ErrorIcon, Warning as WarningIcon, Info as InfoIcon } from '@mui/icons-material';

export const SEVERITY_CHIP = {
  30: { label: 'Kritisk', color: 'error' },
  20: { label: 'Advarsel', color: 'warning' },
  10: { label: 'Info', color: 'info' },
  0:  { label: 'OK', color: 'success' },
};

// Maps severity code to MUI Alert/Chip color string
export const SEVERITY_ALERT = { 30: 'error', 20: 'warning', 10: 'info' };

// Maps severity code to icon element
export const SEVERITY_ICON = {
  30: <ErrorIcon fontSize="small" color="error" />,
  20: <WarningIcon fontSize="small" color="warning" />,
  10: <InfoIcon fontSize="small" color="info" />,
};

export const DEVIATION_LABELS = {
  variationOutsidePlan: 'Arbejde uden for plan',
  hasOverTimeLogged: 'Merarbejde registreret',
  missingClockOut: 'Manglende check-ud',
  missingClockIn: 'Manglende check-ind',
  pauseDeviation: 'Pauseafvigelse',
  lateArrival: 'Sen ankomst',
  earlyDeparture: 'Tidlig afgang',
  unplannedAbsence: 'Uplanlagt fravær',
};
